import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class PaginationControl extends Component {
  static propTypes = {
    total: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    onChange: () => {},
  };

  state = {
    manualEntry: this.props.page,
  };

  // Update the text box if the prop changes.
  componentWillReceiveProps (props) {
    this.setState({ manualEntry: props.page });
  }

  // An accessor for the total number of pages derived from props.
  totalPages () {
    if (this.props.limit === 0) {
      return 0;
    }
    return Math.ceil(this.props.total / this.props.limit);
  }

  prevButtonEnabled () {
    return this.props.page !== 1;
  }

  nextButtonEnabled () {
    return this.props.page < this.totalPages();
  }

  // This intercepts an 'enter' keypress.
  // If the entered number is a valid page, notify the user of the component the page has changed.
  // If the entered numberis not a valid page, we go to the nearest valid page.
  // if the entered string is not a number, we reset the manual input to the current page.
  handleManualEntryKeypress (event) {
    if (event.key === 'Enter') {
      let page = Number(this.state.manualEntry);
      if (Number.isNaN(page)) {
        this.setState({ manualEntry: this.props.page });
      } else {
        if (page > this.totalPages()) {
          page = this.totalPages();
        }
        if (page < 1) {
          page = 1;
        }
        if (page !== this.props.page) {
          this.props.onChange(page);
        } else {
          this.setState({ manualEntry: page });
        }
      }
    }
  }

  render () {
    return (
      <div className="pagination-controls">
        <button
          className={classnames([
            'pagination-button',
            this.prevButtonEnabled() ? 'active' : 'inactive',
          ])}
          onClick={this.prevButtonEnabled() ? () => this.props.onChange(this.props.page - 1) : null}>
          <span className="fa fa-caret-left" aria-hidden="true" />
        </button>
        &nbsp;
        <div className="manual-entry-label">
          Page
          <input
            type="text"
            className="manual-entry"
            value={this.state.manualEntry}
            onChange={event => this.setState({ manualEntry: event.target.value })}
            onKeyPress={event => this.handleManualEntryKeypress(event)} />
            / {this.totalPages()}
        </div>
        <div className="subscriber-range-label">
          Subscriber No. {((this.props.page - 1) * this.props.limit) + 1}&ndash;
          {Math.min(this.props.page * this.props.limit, this.props.total)}
        </div>
        <button
          className={classnames([
            'pagination-button',
            this.nextButtonEnabled() ? 'active' : 'inactive',
          ])}
          onClick={this.nextButtonEnabled() ? () => this.props.onChange(this.props.page + 1) : null}>
          <span className="fa fa-caret-right" aria-hidden="true" />
        </button>
      </div>
    );
  }
}

module.exports = PaginationControl;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/pagination_control.jsx